import ApiClient from '../../../lib/ApiClient'

const authService = {
  async login(email, password) {
    try {
      const response = await ApiClient.post('/auth/generate', {
        email,
        password,
        deviceInfo: this.generateDeviceInfo(),
      })
      // El servidor establece las cookies httpOnly automáticamente.
      // El body contiene los datos del usuario (sin tokens).
      return response.data
    } catch (error) {
      throw new Error(this.handleAuthError(error))
    }
  },

  async logout() {
    try {
      await ApiClient.post('/auth/logout', {}, { timeout: 5000 })
    } catch (error) {
      console.warn('Error no crítico durante logout:', error.message)
    }
  },

  async verifyToken() {
    try {
      const response = await ApiClient.get('/auth/verify')
      return {
        isValid: response.data?.isValid || false,
        userData: response.data,
      }
    } catch (error) {
      console.error('Error verificando token:', error.message)
      return { isValid: false }
    }
  },

  async refreshToken() {
    try {
      const response = await ApiClient.post('/auth/refresh')
      return response.data
    } catch (error) {
      throw new Error(this.handleAuthError(error))
    }
  },

  generateDeviceInfo() {
    return `WebApp/${navigator.platform} (${navigator.userAgent})`
  },

  handleAuthError(error) {
    if (!error.response) {
      return error.message?.includes('Network Error')
        ? 'No hay conexión con el servidor'
        : 'Error de red. Verifica tu conexión.'
    }

    const status = error.response.status
    const errorData = error.response.data || {}
    const apiMessage = errorData.message || errorData.error || ''

    const isNotVerified =
      apiMessage.toLowerCase().includes('no verificada') ||
      apiMessage.toLowerCase().includes('account_not_verified')

    if (isNotVerified) {
      return 'Cuenta no verificada. Revisa tu email para activar tu cuenta.'
    }

    const errorMap = {
      400: apiMessage || 'Solicitud incorrecta',
      401: 'Credenciales inválidas',
      403: 'Acceso no autorizado',
      429: 'Demasiados intentos. Por favor espera.',
      500: 'Error interno del servidor',
    }

    const specificMessages = {
      invalid_credentials: 'Email o contraseña incorrectos',
      account_not_verified: 'Cuenta no verificada',
      token_expired: 'Sesión expirada',
      token_revoked: 'Sesión finalizada en otro dispositivo',
    }

    return (
      specificMessages[apiMessage] ||
      errorMap[status] ||
      `Error ${status}: ${apiMessage}`
    )
  },
}

export default authService
